import { Form as FormikForm } from "formik"

import {
    styled,
    FormikAutoComplete,
    FormikSelect,
    FormikTextField as L2RFormikTextField,
    TextField,
    Typography,
    Box
} from "@l2r-front/l2r-ui"

export const Form = styled(FormikForm)(() => ({
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
}))

export const FormContent = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(6),
    flex: "1 1 0",
    paddingTop: theme.spacing(2),
    alignItems: "center",
}))

export const TaskTypeContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(10),
    alignItems: "center",
    width: "100%",
}))

export const TaskTypeSelect = styled(FormikSelect)(() => ({
    flexGrow: 1,
}))

type InfoContainerProps = {
    severity: "info" | "default"
}

export const InfoContainer = styled("div", { shouldForwardProp: (prop) => prop !== "severity" })<InfoContainerProps>((({ theme, severity }) => ({
    alignItems: "flex-start",
    backgroundColor: severity === "info" ? theme.palette["_components/alert/info/background"].main : theme.palette["common/gray_states"].light,
    color: severity === "info" ? theme.palette["_components/alert/info/color"].main : theme.palette["common/black_states"].main,
    borderRadius: theme.spacing(3),
    display: "flex",
    margin: theme.spacing(4),
    padding: theme.spacing(2, 3),
})))

export const InfoText = styled(Typography)(({ theme }) => ({
    marginLeft: theme.spacing(3),
}))

export const MoreTasksContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1, 0, 1, 4),
}))

export const TaskCategory = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(3),
    padding: theme.spacing(1, 4),
}))

export const QuantitySelect = styled(L2RFormikTextField)(() => ({
    width: "100%",

    "& .MuiInputAdornment-root": {
        height: "100%",
    },
}))

export const UnitSelect = styled(FormikAutoComplete)(() => ({
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
}))

export const TextFieldInput = styled(TextField)(() => ({
    width: 150,

    "input": {
        textAlign: "right",
    },
}))

export const FormikTextField = styled(L2RFormikTextField)(() => ({
    width: "100%",
}))